export function getView(claim_charges, invoice_charges) {
  // only show Tabs when both types of receivables are displayed
  return claim_charges.length && invoice_charges.length
}
